/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Presencetype1Inputs */

const en__field_presencetype1 = /** @type {(inputs: _Field_Presencetype1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Presence`)
};

const de__field_presencetype1 = /** @type {(inputs: _Field_Presencetype1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Präsenz`)
};

/**
* | output |
* | --- |
* | "Presence" |
*
* @param {_Field_Presencetype1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_presencetype1 = /** @type {((inputs?: _Field_Presencetype1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Presencetype1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_presencetype1(inputs)
	return de__field_presencetype1(inputs)
});
export { _field_presencetype1 as "_field_presenceType" }